import SearchIcon from '@mui/icons-material/Search';
import SportsScoreIcon from '@mui/icons-material/SportsScore';
import TodayIcon from '@mui/icons-material/Today';
import { FormControl, FormHelperText, Input, InputAdornment, InputLabel } from '@mui/material';
import { useEffect, useMemo, useState } from "react";
import { Card, Col, Container, Image, Row } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import Jet from '../../assets/images/Jetski.svg';
import Lancha from '../../assets/images/Lancha.svg';
import TableContainer from "../../components/table-container.component";
import { useAlertMessageContext } from "../../contexts/alert-message.context";
import lclService from "../../services/lcl.service";
import { AlertMessageEnum, EDeliveryStatus, getDeliveryStatus, getVessel } from "../../utilities/types";
import DashboardHeader from "../headers/dashboard.header";
import styles from './DeliveryMovementDashboard.module.scss';
import TimerIcon from '@mui/icons-material/Timer';
import CancelIcon from '@mui/icons-material/Cancel';
import DeliveryOrderModal from './delivery-order-modal/DeliveryOrderModal';
import { usePartnerContext } from '../../contexts/partner.context';
import { isEmpty } from '../../utilities/validators';
import authService from '../../services/auth.service';
import { TFilter } from '../../types/FilterType';
import { dateToString, notNullToDate, toInt } from '../../utilities/auxiliary-functions';
import { removeFormatDate } from '../../utilities/masks';
import dlvService from '../../services/dlv.service';
import cduService from '../../services/cdu.service';

interface IDeliveryMovementDashboardProps {
    
}

export const DeliveryMovementDashboard: React.FC<IDeliveryMovementDashboardProps> = () => {
    
	let { partner } = usePartnerContext();
    const alertContext = useAlertMessageContext();
    const navigator = useNavigate();
  
    const title = "Gestão Movimentação do Delivery";
    const description = "";

    const [ textSearch, setTextSearch ] = useState('');
    const [ selectedOrder, setSelectedOrder ] = useState();
    const [ selectedFilter, setSelectedFilter] = useState('all')
    const [ originalRecords, setOriginalRecords ] = useState([]);
    const [ pendingOrders, setPendingOrders ] = useState([]);
    const [ canceledOrders, setCanceledOrders ] = useState([]);
    const [ finishedOrders, setFinishedOrders ] = useState([]);
    const [ records, setRecords ] = useState([]);
    const [ openConfirmationModal, setOpenConfirmationModal ] = useState(false)
    const [ modalType, setModalType ] = useState('')

    const columnsRecord = useMemo(() => [{
        Header: 'Data | Hora',
        accessor: "launch",
        Cell: (row: any) => {
            return (
                <>
                    <div className={`mt-2 ${styles.info}`}>{new Date(row.value).toLocaleDateString('pt-BR')}</div>
                    <div className={`mt-1 ${styles.info}`}>{new Date(row.value).toLocaleTimeString('pt-BR')}</div>
                </>
            )
        }
    },{
        Header: 'Nome | ID',
        Cell: (param: any) => {
            const { vessel } = param.row.original;

            return (
                <div className={`${styles.info} d-flex flex-column align-items-center justify-content-center`}>
                    <div className={`${styles.info} white-space mt-2`}>{vessel?.name}</div>
                    <div className="white-space mt-1">{vessel?.identifyKey}</div>
                </div>
            );
        }
    },{
        Header: 'TIPO | COR',
        Cell: (param: any) => {
            const { vessel } = param.row.original;

            return getVessel(vessel?.typeVessel).id === 34 ? (
                <div className="d-flex flex-column align-items-center justify-content-center mb-2">
                    <div className="mt-2 d-flex justify-content-center mb-2">
                        <Image src={Lancha} className="jet" style={{height: 32}}/>
                        <small className="ms-2">{`${vessel?.vesselSize}'`}</small>
                    </div>
                <span className={styles.vesselColor} style={{backgroundColor: `${vessel?.color}`}}></span>
                </div>
            ):(
                <div className="d-flex flex-column align-items-center justify-content-center mb-2">
                    <div className="d-flex justify-content-center mb-2">
                        <Image src={Jet} className="jet mt-3" style={{height: 32}}/>
                        <small className="ms-1 mt-3">{`10'`}</small>
                    </div>
                    <span className={styles.vesselColor} style={{backgroundColor: `${vessel?.color}`}}></span>
                </div>
            )
        }
    },{
        Header: 'MAR | MOD',
        Cell: (param: any) => {
            const { vessel } = param.row.original;

            return (
                <div className="d-flex flex-column align-items-center justify-content-center">
                    <div className={`${styles.info} white-space mt-2`}>{vessel?.manufacturer}</div>
                    <div className="white-space mt-1">{vessel?.modal}</div>
                </div>
            )
        }
    },{
        Header: 'Localizador',
        Cell: (param: any) => {
            const { movement} = param.row.original;

            return (
                <div className={`${styles.info} mt-4`}>
                    {movement?.locator}
                </div>
            );
        }
    },{
        Header: 'Pedido | Status',
        // accessor: 'status',
        Cell: (param: any) => {
            const deliver = param.row.original;

            return <>
                <div className="mt-2 d-flex flex-column align-items-center">
                    <span className={`${styles.orderNumber} ${deliver.id} `}>{deliver.id}</span>
                    <span className={`${styles.orderStatus} mt-1 mb-1 ${toInt(deliver.status) === EDeliveryStatus.PENDING ? styles.pending : toInt(deliver.status) === EDeliveryStatus.CANCELED ? styles.canceled : toInt(deliver.status) === EDeliveryStatus.FINISHED ? styles.finished : styles.requested}`}>
                        {getDeliveryStatus(deliver.status)}
                    </span>
                </div>
            </>
        }
    },{
        Header: 'Pagamento',
        Cell: (param: any) => {
            const deliver = param.row.original;

            return (
                <div className={`${styles.info} mt-4`}>
                    {deliver.payment === 'MONTHLY' ? 'Mensalista' : deliver.payment === 'SINGLE' ? 'Avulso' : '-'}
                </div>
            );
        }
    },{
        Header: 'Operador',
        Cell: (param: any) => {
            const deliver = param.row.original;

            return (
                <div className={`${styles.info} mt-4`}>
                    {deliver.operator}
                </div>
            )
        }    
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }], []); // columnsRecord

    async function getOrders() {
        if (!isEmpty(partner)) {
            try {
                let date = new Date();
                let baseDate = notNullToDate(date, "dd/mm/yyyy");

                const filter = {
                    where: {
                        launch: {
                            start: removeFormatDate(baseDate + " 00:00:00"),
                            end: removeFormatDate(baseDate + " 23:59:59")
                        }
                    },
                    order: [ [ 'launch', 'ASC' ] ],
                } as TFilter;
                const deliverSearch = await dlvService.deliverSearch(filter);
                const deliverList = [] as any;
                records.forEach((record: any) => deliverList.push(record));
                deliverSearch.rows.forEach((record: any) => deliverList.push(record));

                for (let r = 0; r < deliverList.length; r++) {
                    const deliver = deliverList[r] as any;
                    if (deliver.applicant === 'VESSEL') {
                        deliver.vessel = await lclService.vesselById(deliver.applicantId);
                        const filterMovement = {
                            where: {
                                dateMovement: {
                                    start: removeFormatDate(dateToString(deliver.launch, 'dd/mm/yyyy') + " 00:00:00"),
                                    end: removeFormatDate(dateToString(deliver.launch, 'dd/mm/yyyy') + " 23:59:59")
                                },
                                vesselId: deliver.vessel?.id
                            },
                            order: [ [ 'dateMovement', 'ASC' ] ],
                        } as TFilter;
                        const resultMov = await lclService.movementVesselFilter(filterMovement);
                        deliver.movement = resultMov.rows;
                    } else if (deliver.applicant === 'MEMBER') {
                        deliver.member = await lclService.memberById(deliver.applicantId);
                    } else if (deliver.applicant === 'EMPLOYEE') {
                        deliver.employee = await cduService.employeeById(deliver.applicantId);
                    }
                    
                    const attributes: string[] = ['id', 'productId', 'quantity', 'amount', 'observation'];
                    const resultItems = await dlvService.itemList(deliver.id, attributes);
                    deliver.deliverItems = resultItems.rows;
                }

                setRecords(deliverList);
                setOriginalRecords(deliverList);
                const pending = deliverList.filter((parsed: any) => 
                    toInt(parsed.status) === EDeliveryStatus.PENDING
                )?.length || 0
                setPendingOrders(pending)
                const canceled = deliverList.filter((parsed: any) => 
                    toInt(parsed.status) === EDeliveryStatus.CANCELED
                )?.length || 0
                setCanceledOrders(canceled)
                const finished = deliverList.filter((parsed: any) => 
                    toInt(parsed.status) === EDeliveryStatus.FINISHED
                )?.length || 0
                setFinishedOrders(finished)
            } catch(error: any) {
                await alertContext.show(AlertMessageEnum.FAIL, 'Delivery', error);
            }
        } else {
            await alertContext.show(AlertMessageEnum.FAIL, 'Delivery', 'Não foi definido uma Marina para exibir o cadastro !');
            navigator(`/portal`);
        }
    } // searchfilter

    const filterOrderBySearch = (key?: string, value?: string) => {

        const filteredOrders: any = []
        records.filter((record: any) => {
            if (
                record.identifyKey
                    .toLocaleLowerCase()
                    .includes(textSearch.toLocaleLowerCase()) ||
                record.name
                    .toLocaleLowerCase()
                    .includes(textSearch.toLocaleLowerCase()) ||
                record.enrollment
                    .toLocaleLowerCase()
                    .includes(textSearch.toLocaleLowerCase())
            )
            filteredOrders.push(record)
            return record
        })
        setRecords(filteredOrders)
        return ''
    }

    useEffect(() => {
        if (textSearch.length >= 3) {
            filterOrderBySearch()
        } else if (textSearch.length < 3) {
            setRecords(originalRecords)
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [textSearch]);

    useEffect(() => {
        if (isEmpty(partner))
            // eslint-disable-next-line react-hooks/exhaustive-deps
            partner = authService.currentPartner();
        getOrders()
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const viewOrder = (order: any) => {
        setSelectedOrder(order)
        setOpenConfirmationModal(true)
    }

    const filterOrders = (filter: string) => {
        setSelectedFilter(filter)
        if (filter === 'all') {
            setRecords(originalRecords)
        }
        if (filter === 'pending') {
            const filteredOrders = originalRecords.filter((record: any) => toInt(record.status) === EDeliveryStatus.PENDING)
            setRecords(filteredOrders)
        }
        if (filter === 'canceled') {
            const filteredOrders = originalRecords.filter((record: any) => toInt(record.status) === EDeliveryStatus.CANCELED)
            setRecords(filteredOrders)
        }
        if (filter === 'finished') {
            const filteredOrders = originalRecords.filter((record: any) => toInt(record.status) === EDeliveryStatus.FINISHED)
            setRecords(filteredOrders)
        }
    }

    const onConfirmModal = (order: any) => {
        console.log(order)
    }

    const onCloseModal = (event: any, reason: any) => {
        // event.preentDefault();
        if (reason && reason === 'backdropClick') return
        setOpenConfirmationModal(false);
        setModalType('');
        setRecords([]);
        setOriginalRecords([]);
        getOrders();
    }

    function viewDashboard() {

        return (
            <Container fluid className="dashboard-body financial">
                <Row>
                    <Col md={12} className="page-sweet">
                    <Card className={styles.vesselList}>
                        <Card.Header>
                            <Card.Title>Pedidos</Card.Title>
                        </Card.Header>
                        <Card.Body style={{ minHeight : 500 }}>
                            <div className="d-flex justify-content-between">
                                <FormControl fullWidth sx={{width: 300, marginBottom: 2 }} variant="standard">
                                    <InputLabel className={styles.label} htmlFor="standard-adornment-amount">Pesquisar
                                    </InputLabel>
                                    <Input id="standard-adornment-amount" value={textSearch} onChange={(e)=>
                                    setTextSearch(e.target.value)}
                                    endAdornment = {
                                    <InputAdornment position="end">
                                        <SearchIcon className='isClickable' />
                                    </InputAdornment>
                                    }
                                    />
                                    <FormHelperText id="component-helper-text">
                                        ID, Nome ou Registro da Embarcação
                                    </FormHelperText>
                                </FormControl>
                                <div className={styles.statusButtonsWrapper}>
                                    <div className={`${styles.statusButton} ${ selectedFilter==='all' ? styles.active
                                        : '' }`} role="presentation" onClick={() => filterOrders('all')}
                                        >
                                        <TodayIcon sx={{ fontSize: 32 }} />
                                        <span className="ms-2">{originalRecords?.length || 0}</span>
                                    </div>
                                    <div className={`${styles.statusButton} ${ selectedFilter==='pending' ?
                                        styles.active : '' }`} role="presentation" onClick={()=>
                                        filterOrders('pending')}
                                        >
                                        <TimerIcon color="warning" sx={{ fontSize: 32 }} />
                                        <span className="ms-2">{pendingOrders}</span>
                                    </div>
                                    <div className={`${styles.statusButton} ${ selectedFilter==='canceled' ?
                                        styles.active : '' }`} role="presentation" onClick={()=>
                                        filterOrders('canceled')}
                                        >
                                        <CancelIcon color="error" sx={{ fontSize: 32 }} />
                                        <span className="ms-2">{canceledOrders}</span>
                                    </div>
                                    <div className={`${styles.statusButton} ${ selectedFilter==='finished'?
                                        styles.active : '' }`} role="presentation" onClick={()=>
                                        filterOrders('finished')}
                                        >
                                        <SportsScoreIcon sx={{ fontSize: 32 }} />
                                        <span>{finishedOrders}</span>
                                    </div>
                                </div>

                            </div>

                            <TableContainer 
                                setSelectedRow={ (event: any, dataRow: any)=> {
                                    viewOrder(dataRow);
                                }} 
                                className={'table-list-record'} 
                                columns={columnsRecord} 
                                data={records}
                                viewPagination={records.length > 10}/>
                        </Card.Body>
                    </Card>
                    </Col>
                </Row>
                {openConfirmationModal && (
                    <DeliveryOrderModal
                        open={openConfirmationModal}
                        handleClose={onCloseModal}
                        height="fit-content"
                        width={450}
                        order={selectedOrder}
                        type={modalType}
                        onConfirm={(order: any) => onConfirmModal(order)}
                        onCancel={onCloseModal}
                    />
                )}
            </Container>
        );
    }

    return (
        <div className="dashboard">
            <DashboardHeader title={title} description={description} />
            {viewDashboard()}
        </div>
    );
}

export default DeliveryMovementDashboard;
